export default __webpack_public_path__ + "img/woman-illustration.47e64da9.svg";